import React from "react";
import Toolbar from "./components/Toolbar";
import { RichTextEditorToolbarProps } from "./utils/types/types";

const RichTextEditorToolbar: React.FC<RichTextEditorToolbarProps> = ({
  editor,
  onAttachmentsChange,
  onImageInsert,
  schema,
  toolbarExtraClass,
  wrapperClass,
  mentionActiveUsersList,
  setTaggedUsers,
  groupedToolbarOrder,
}) => {
  if (!editor) return null;

  return (
    <div className={`shrink-0 z-10 ${wrapperClass ?? ""}`}>
      <Toolbar
        editor={editor}
        onAttachmentsChange={onAttachmentsChange}
        onImageInsert={onImageInsert}
        schema={schema}
        toolbarExtraClass={toolbarExtraClass}
        mentionActiveUsersList={mentionActiveUsersList}
        setTaggedUsers={setTaggedUsers}
        groupedToolbarOrder={groupedToolbarOrder}
      />
    </div>
  );
};

export default RichTextEditorToolbar;
